import PublicLayout from '../components/PublicLayout.jsx';
import BookedInfoSection from '../components/BookedInfoSection.jsx';

export default function JadwalPage() {
  return (
    <PublicLayout>
      <div className="h-24" />
      <BookedInfoSection />
    </PublicLayout>
  );
}
